import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import { parse } from 'query-string';

var LocaleResolver =
/*#__PURE__*/
function () {
  function LocaleResolver(detectors, transformers) {
    if (transformers === void 0) {
      transformers = [];
    }

    _defineProperty(this, "locales", void 0);

    _defineProperty(this, "transformers", void 0);

    this.locales = detectors.map(function (detector) {
      return detector.getLocales();
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);
    this.transformers = transformers;
  }

  var _proto = LocaleResolver.prototype;

  _proto.getLocales = function getLocales(transformers) {
    if (transformers === void 0) {
      transformers = [];
    }

    var locales = this.locales;
    [].concat(this.transformers, transformers).forEach(function (transformer) {
      locales = transformer.transform(locales);
    });
    return locales.filter(function (value, index, array) {
      return array.indexOf(value) === index;
    });
  };

  return LocaleResolver;
}();
/**
 * Detector classes obtain list of user's locales. It can be from browser, url, cookies, storage, ... whatever you want
 * Get locales method always return array of locales.
 */


var Detector = function Detector() {};
/**
 * Navigator detector try load locales from browser navigator variable.
 */


var NavigatorDetector =
/*#__PURE__*/
function (_Detector) {
  _inheritsLoose(NavigatorDetector, _Detector);
  /**
   * On default languages are loaded from window.navigator
   *
   * @param {Navigator} navigator - browser navigator variable
   */


  function NavigatorDetector(navigator) {
    var _this;

    if (navigator === void 0) {
      navigator = window.navigator;
    }

    _this = _Detector.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "navigator", void 0);

    _this.navigator = navigator;
    return _this;
  }
  /**
   * Get list of locales.
   *
   * @returns {Array<string>} list of locales from browser
   */


  var _proto = NavigatorDetector.prototype;

  _proto.getLocales = function getLocales() {
    // @ts-ignore
    var _this$navigator = this.navigator,
        languages = _this$navigator.languages,
        language = _this$navigator.language,
        userLanguage = _this$navigator.userLanguage;

    if (Array.isArray(languages)) {
      return languages;
    }

    if (language) {
      return [language];
    }

    if (userLanguage) {
      return [userLanguage];
    }

    return [];
  };

  return NavigatorDetector;
}(Detector);
/**
 * This detector load locales from GET parameters. The value should be locale separated list.
 */


var UrlDetector =
/*#__PURE__*/
function (_Detector) {
  _inheritsLoose(UrlDetector, _Detector);
  /**
   * Constructor
   *
   * @param {string} parameter - Which parameter to look for.
   * @param {Location} location - window.location is used on default
   */


  function UrlDetector(parameter, location) {
    var _this;

    if (location === void 0) {
      location = window.location;
    }

    _this = _Detector.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "location", void 0);

    _defineProperty(_assertThisInitialized(_this), "parameter", void 0);

    _this.location = location;
    _this.parameter = parameter;
    return _this;
  }
  /**
   * Get list of locales from browser url.
   *
   * @returns {Array<string>} list of locales
   */


  var _proto = UrlDetector.prototype;

  _proto.getLocales = function getLocales() {
    var locales = parse(this.location.search)[this.parameter] || null;

    if (typeof locales === 'string') {
      return locales.split(',');
    }

    return [];
  };

  return UrlDetector;
}(Detector);
/**
 * With FromListDetector you can set locales by your own.
 */


var FromListDetector =
/*#__PURE__*/
function (_Detector) {
  _inheritsLoose(FromListDetector, _Detector);
  /**
   * @param {Array<string>} locales - list of locales
   */


  function FromListDetector(locales) {
    var _this;

    _this = _Detector.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "locales", void 0);

    _this.locales = locales;
    return _this;
  }
  /**
   * Get list your of locales.
   *
   * @returns {Array<string>} list of your locales
   */


  var _proto = FromListDetector.prototype;

  _proto.getLocales = function getLocales() {
    return this.locales;
  };

  return FromListDetector;
}(Detector);

var index = {
  __proto__: null,
  Detector: Detector,
  NavigatorDetector: NavigatorDetector,
  UrlDetector: UrlDetector,
  FromListDetector: FromListDetector
};
/**
 * Transformer are used to change format of locale (eg. convert it to uppercase), create fallbacks or delete invalid items.
 */

var Transformer = function Transformer() {};
/**
 * This transformers create fallbacks from complex locales to simpliest.
 * 'en-US-east' => ['en-US-east', 'en-US', 'en']
 * 'es-ES' => ['es-ES', 'es']
 */


var FallbacksTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inheritsLoose(FallbacksTransformer, _Transformer);

  function FallbacksTransformer() {
    return _Transformer.apply(this, arguments) || this;
  }

  var _proto = FallbacksTransformer.prototype;
  /**
   * Add fallbacks to locales. Locales should be in IETF language tag format.
   *
   * @param {Array<string>} locales - list of locales
   * @returns {Array<string>} locales with fallbacks
   */

  _proto.transform = function transform(locales) {
    return locales.map(function (locale) {
      var splitedLocale = locale.split('-');
      return splitedLocale.map(function (value, index) {
        var localeGenerator = [];

        for (var i = 0; i <= index; i++) {
          localeGenerator.push(splitedLocale[i]);
        }

        return localeGenerator.join('-');
      }).reverse();
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []);
  };

  return FallbacksTransformer;
}(Transformer);
/**
 * This transformer convert locales to standard IETF language tag.
 */


var IETFTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inheritsLoose(IETFTransformer, _Transformer);
  /**
   * Constructor.
   *
   * @param {string} localeSeparator - how is locales parts separated
   */


  function IETFTransformer(localeSeparator) {
    var _this;

    if (localeSeparator === void 0) {
      localeSeparator = '-';
    }

    _this = _Transformer.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "localeSeparator", void 0);

    _this.localeSeparator = localeSeparator;
    return _this;
  }
  /**
   * Convert locales to standard IETF language tag.
   *
   * @param {Array<string>} locales - list of locales
   * @returns {Array<string>} list of transformed locales
   */


  var _proto = IETFTransformer.prototype;

  _proto.transform = function transform(locales) {
    var _this2 = this;

    return locales.map(function (locale) {
      return locale.split(_this2.localeSeparator).map(function (value, index) {
        return index === 1 ? value.toUpperCase() : value.toLowerCase();
      }).join('-');
    });
  };

  return IETFTransformer;
}(Transformer);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultConvertTable = {
  'es-XL': 'es-419',
  hindi: 'hi',
  indonesian: 'id',
  english: 'en'
};
/**
 * It convert invalid locales.
 */

var InvalidLocalesTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inheritsLoose(InvalidLocalesTransformer, _Transformer);
  /**
   * Constructor.
   *
   * @param {SimpleObject} convertTable - simple convert table
   */


  function InvalidLocalesTransformer(convertTable) {
    var _this;

    if (convertTable === void 0) {
      convertTable = {};
    }

    _this = _Transformer.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "convertTable", void 0);

    _this.convertTable = _objectSpread({}, defaultConvertTable, {}, convertTable);
    return _this;
  }
  /**
   * Transform invalid languages.
   *
   * @param {Array<string>} locales - list of locales
   * @returns {Array<string>} cleaned list of locales
   */


  var _proto = InvalidLocalesTransformer.prototype;

  _proto.transform = function transform(locales) {
    var _this2 = this;

    return locales.map(function (locale) {
      return _this2.convertTable[locale] || locale;
    });
  };

  return InvalidLocalesTransformer;
}(Transformer);
/**
 * Transform all locales to languages only with region variant.
 */


var LanguageOnlyTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inheritsLoose(LanguageOnlyTransformer, _Transformer);

  function LanguageOnlyTransformer() {
    return _Transformer.apply(this, arguments) || this;
  }

  var _proto = LanguageOnlyTransformer.prototype;
  /**
   * Transform locales to languages only with region variant.
   *
   * @param {Array<string>} locales - list of locales
   * @returns {Array<string>} - list of languages
   */

  _proto.transform = function transform(locales) {
    return locales.map(function (locale) {
      return locale.split('-')[0];
    });
  };

  return LanguageOnlyTransformer;
}(Transformer);
/**
 * This transformer allows you to append default locale.
 */


var DefaultLocaleTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inheritsLoose(DefaultLocaleTransformer, _Transformer);
  /**
   * Constructor.
   *
   * @param {string} defaultLocale - set default locale
   */


  function DefaultLocaleTransformer(defaultLocale) {
    var _this;

    _this = _Transformer.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "defaultLocale", void 0);

    _this.defaultLocale = defaultLocale;
    return _this;
  }
  /**
   * Add default locale to end of array
   *
   * @param {Array<string>} locales - list of locales
   * @returns {Array<string>} locales with default
   */


  var _proto = DefaultLocaleTransformer.prototype;

  _proto.transform = function transform(locales) {
    var transformedLocales = [].concat(locales.map(function (locale) {
      var splitedLocale = locale.split('-');
      return splitedLocale.map(function (value, index) {
        var localeGenerator = [];

        for (var i = 0; i <= index; i++) {
          localeGenerator.push(splitedLocale[i]);
        }

        return localeGenerator.join('-');
      }).reverse();
    }).reduce(function (a, b) {
      return a.concat(b);
    }, []), [this.defaultLocale]); // slice locales that comes after default locale

    return transformedLocales.slice(0, transformedLocales.indexOf(this.defaultLocale) + 1);
  };

  return DefaultLocaleTransformer;
}(Transformer);
/**
 * This transformer allows you to filter locales
 */


var AllowOnlyTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inheritsLoose(AllowOnlyTransformer, _Transformer);
  /**
   * Constructor.
   *
   * @param {Array<string>} allowedLocales - list of allowed locales
   */


  function AllowOnlyTransformer(allowedLocales) {
    var _this;

    _this = _Transformer.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "allowedLocales", void 0);

    _this.allowedLocales = allowedLocales;
    return _this;
  }
  /**
   * Return only allowed locales.
   *
   * @param {Array<string>} locales - list of locales
   * @returns {Array<string>} allowed locales
   */


  var _proto = AllowOnlyTransformer.prototype;

  _proto.transform = function transform(locales) {
    var _this2 = this;

    return locales.filter(function (locale) {
      return _this2.allowedLocales.includes(locale);
    });
  };

  return AllowOnlyTransformer;
}(Transformer);

var index$1 = {
  __proto__: null,
  Transformer: Transformer,
  FallbacksTransformer: FallbacksTransformer,
  IETFTransformer: IETFTransformer,
  InvalidLocalesTransformer: InvalidLocalesTransformer,
  LanguageOnlyTransformer: LanguageOnlyTransformer,
  DefaultLocaleTransformer: DefaultLocaleTransformer,
  AllowOnlyTransformer: AllowOnlyTransformer
};
export { index as DETECTORS, LocaleResolver, index$1 as TRANSFORMERS };